import { render, staticRenderFns } from "./contractConfirmation.vue?vue&type=template&id=35eca560&scoped=true&"
import script from "./contractConfirmation.vue?vue&type=script&lang=js&"
export * from "./contractConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./contractConfirmation.vue?vue&type=style&index=0&id=35eca560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eca560",
  null
  
)

export default component.exports